import { useStateRef } from '@op/hooks/common';
import useLanguage from '@op/hooks/useLanguage';
import { DBO_T } from '@op/utils/format';
import { SummaryTabItem } from '../types';
import { useEffect, useMemo } from 'react';

export function useMdToHtml({
  item,
  watch = false,
}: {
  item: SummaryTabItem;
  watch?: boolean;
}) {
  const { isEn } = useLanguage();

 

  function getDefaultText(data: SummaryTabItem) {
    const text = isEn ? data.summary : data.summaryCn;
    if (!text) return '';
    const { html } = DBO_T.mdToHtml(text);
    const processedHtml = DBO_T.editorPreprocessHtml(html); 
    return processedHtml;
  }

  const [renderHtmlRef, renderHtml, setRenderHtml] = useStateRef<string>(
    getDefaultText(item),
  );

  useEffect(() => {
    if (watch) {
      setRenderHtml(getDefaultText(item));
    }
  }, [item, isEn]);

  const isEmpty = useMemo(() => {
    const cleanedText = renderHtml
      ?.replace(/<p>|<\/p>|<br>|&nbsp;|\s+/g, '')
      .trim();


    return !cleanedText || cleanedText.length === 0;
  }, [renderHtml]);

  return { isEmpty, renderHtml, setRenderHtml, renderHtmlRef, getDefaultText };
}
